import { useFadeIn } from '@hooks/useFadeIn'
import { formatDate } from '@/utils/markdown'
import postsData from '../../blog/posts.json'

interface BlogPost {
  id: string
  slug: string
  title: string
  excerpt: string
  date: string
  category: string
  tags: string[]
  voiceRecorded: boolean
  readTime?: string
  featured?: boolean
}

export type { BlogPost }

export function Writing({ onPostClick }: { onPostClick: (post: BlogPost) => void }) {
  const fade = useFadeIn()
  const sortedPosts = [...(postsData as BlogPost[])]
    .sort((a, b) => {
      if (a.featured && !b.featured) return -1
      if (!a.featured && b.featured) return 1
      return new Date(b.date).getTime() - new Date(a.date).getTime()
    })

  return (
    <section id="writing" ref={fade.ref as React.RefObject<HTMLElement>} className={`modern-section ${fade.className}`}>
      <p className="modern-section__label">Writing</p>
      <h2 className="modern-section__title">Thought log</h2>
      <div className="modern-posts">
        {sortedPosts.map((post) => (
          <article
            key={post.id}
            className={`modern-post modern-post--clickable${post.featured ? ' modern-post--featured' : ''}`}
            onClick={() => onPostClick(post)}
            role="link"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter') onPostClick(post) }}
          >
            <div className="modern-post__meta">
              {post.featured && (
                <span className="modern-post__badge">Featured</span>
              )}
              <time className="modern-post__date">{formatDate(post.date)}</time>
              <span className="modern-post__category">{post.category}</span>
              {post.voiceRecorded && (
                <span className="modern-post__voice">voice-recorded</span>
              )}
              {post.readTime && (
                <span className="modern-post__date">{post.readTime}</span>
              )}
            </div>
            <h3 className="modern-post__title">{post.title}</h3>
            <p className="modern-post__excerpt">{post.excerpt}</p>
            {post.tags && post.tags.length > 0 && (
              <div className="modern-card__tech">
                {post.tags.map((tag: string) => (
                  <span key={tag} className="modern-card__tech-tag">#{tag}</span>
                ))}
              </div>
            )}
          </article>
        ))}
      </div>
    </section>
  )
}
